module.exports = __webpack_public_path__ + "img/2000020.3b0e1ce0.png";